let is_bootstrap_version_4 = () => {
    return is_bootstrap_version(4);
};

let is_bootstrap_version_5 = () => {
    return is_bootstrap_version(5);
};

let is_bootstrap_version = (majorVersion) => {
    if (window.Smart.bootstrapVersion === majorVersion) {
        return true;
    }

    if (typeof bootstrap !== 'undefined' && bootstrap?.Tooltip?.VERSION) {
        if (bootstrap.Tooltip.VERSION.startsWith(majorVersion)) {
            window.Smart.bootstrapVersion = majorVersion;
            return true;
        }
    }

    window.Smart.console.log(`Bootstrap not found.`);
    return false;
};

export {is_bootstrap_version, is_bootstrap_version_4, is_bootstrap_version_5};
